export default __webpack_public_path__ + "static/media/globe.1aeb7b1d.svg";